import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBagShopping, faFile, faLocationPin, faUser} from "@fortawesome/free-solid-svg-icons";
import {formatNumberWithDots, getDateAsReadableFormat, orderPaymentTransactionLabel} from "../../../helper/general";
import Modal from "../../Utilities/Modal";
import {useEffect, useState} from "react";
import ApiRoute from "../../../helper/api";
import {HasAccess} from "../../../helper/permissions";

export default function OrderHoldSubmitModal({order, closeModal, event}){

    const [text, setText] = useState('')
    async function handleSubmit(){
        const res = await ApiRoute.order.action.fn("hold",order,{
            description : text
        })
        try {
            if (res?.status_code >= 200){
                event()
            }
        }catch (e) {
            
        }
    }
    return (
        <Modal isOpen={true} onClose={closeModal}>
            <HasAccess permission={`inventory_confirmation order`} children={
                <div>

                    <div className="page-title z-1 text-right text-sm">
                        <span className="inline-block bg-white pl-3 pr-1 mb-3 relative z-2">هولد سفارش</span>
                    </div>

                    <div className={`flex gap-2 w-full flex-col`}>

                        <input onKeyUp={ (e) => { setText(e.target.value) } } className='px-3 py-2 border border-[#dfdfdf] w-full rounded-[8px] shadow flex-auto bg-white' type="text" placeholder="اینجا بنویسد ..."/>
                        <button onClick={handleSubmit} className={`btn-green rounded max-w-max py-1 px-3`}>ذخیره سازی</button>
                    </div>

                </div>
            }/>
        </Modal>
    )
}